import { Outlet } from "react-router-dom";
import NavBar from "../../components/website/NavBar/NavBar";
import Footer from "../../components/website/Footer/Footer";

export default function WebSite ()
{
    return (
        <>
            <NavBar />
            <Outlet />
            <Footer />
        </>

    );

}